import React from "react";
import {connect} from 'react-redux';
import {fetchRaces} from "../actions";
import MaterialTable from "./MaterialTable";
import _ from 'lodash';
import {CircularProgress} from "@material-ui/core";

class RaceTable extends React.Component{

    componentDidMount(){
        this.props.fetchRaces(this.props.raceName);
    }

    render(){
        const { children, value, index, ...other } = this.props;
        if(!_.isEmpty(this.props.races)){
            return <MaterialTable
                {...other}
                race={this.props.races}
                raceName = {this.props.raceName}/>
               }
        return <div style={{marginTop:'20vh', marginBottom:'20vh',width:'100%',textAlign:'center'}}><div style={{display:'inline-block'}}><CircularProgress size={100}/></div></div>;
    }
}

const mapStateToProps = (state) => {
    return {races:state.races};
}



export default connect(mapStateToProps,{fetchRaces})(RaceTable)
